function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

class QuillEditor extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(ReactQuill, _extends({
        className: 'dark-model-quill',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
            'list': 'ordered'
          }, {
            'list': 'bullet'
          }], ['link'], ['clean']]
        },
        formats: ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image']
      }, this.props, {
        value: this.props.value,
        onChange: this.props.onChange
      }));
    });
  }

}

export default QuillEditor;